import { BloodIndentRequestDetails } from './BloodIndentRequestDetails';
import { Parameter } from './../../../../@core/interfaces/common/parameter';
import { Observable } from 'rxjs';

export interface BloodIndentRequestHeaderParameter extends Parameter {
  searchTerm: number;
  orderBy: string;
}

export interface BloodIndentRequestHeader {
  blIndentDate:any;
  blIndentFrom?: string;
  blRegid: string;
  blIPID: any;
  blRequestBy: string;
  blRequestTenantId: string;
  blRequesterBranchId: string;
  blApproverTenantId: string;
  blApproverBranchId: string;
  blIndentNo: string;
  blIndentStatus: string;
  blapprovalflag: string;
  blsendRequestflag: string;
  blInternalDepartmentId: number;
  createdDate: string;
  updatedBy: any;
  updatedDate: any;
  tenantId: string;
  branchId: string;
  phIndentRequestDetDto: BloodIndentRequestDetails[];
}

export abstract class BloodIndentRequestHeaderData {
  abstract list(url: string): Observable<any[]>;
  abstract getById(url: string): Observable<any>;
  abstract searchList(url: string,data:any): Observable<any>;
  abstract create(url: string,data: any): Observable<any>;
  abstract update(url: string,data: any): Observable<any>;
  abstract delete(url: string): Observable<any>;
}
